module.exports = __webpack_public_path__ + "static/media/HomeTab3.afcc765c.jpg";